var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivateLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 471.22 109.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:url(#linear-gradient);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:#6fc72c;}.cls-6{fill:#6dc72a;}.cls-7{fill:#818386;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-28.64 -28.64)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "65.11 112.23 114.71 83.59 65.11 54.95 65.11 112.23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -156.69,
    y1: 264.85,
    x2: -155.69,
    y2: 264.85,
    gradientTransform: "matrix(49.6, 0, 0, -49.6, 7808.57, 13191.79)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009e3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#039f3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#22ab37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3cb533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#50bd2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5ec22d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#67c52b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69c62b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-28.64 -28.64)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 528.5,
    height: 167.18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 36.47,
    y: 26.32,
    width: 49.6,
    height: 57.27
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M152.81,56.72h-11l-18,43h0A43.4,43.4,0,1,1,126.7,80l7.53-17.75a55,55,0,1,0-1.79,46.47s0,0,0,0h0s1.07-1.86,3.81-10.2H156.4l4,10.2h13.95ZM139.89,88.43,146.5,70.6,153,88.43Z",
    transform: "translate(-28.64 -28.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.17,84a7.31,7.31,0,0,0-2.79-2.13,8.57,8.57,0,0,0-3.6-.81,7.67,7.67,0,0,0-3.45.77,8.2,8.2,0,0,0-2.64,2.06,9.51,9.51,0,0,0-1.73,3,10.42,10.42,0,0,0-.62,3.59,10.87,10.87,0,0,0,.59,3.6,8.61,8.61,0,0,0,1.72,3,8.23,8.23,0,0,0,2.72,2,8.33,8.33,0,0,0,3.56.74,10.09,10.09,0,0,0,3.63-.7,6.9,6.9,0,0,0,2.9-2l6.68,8.15a15.72,15.72,0,0,1-5.87,3.45,23.23,23.23,0,0,1-7.64,1.25,24,24,0,0,1-8.08-1.33,18.69,18.69,0,0,1-6.52-3.85,18.07,18.07,0,0,1-4.36-6.13,21.48,21.48,0,0,1,0-16.22A18.07,18.07,0,0,1,177,76.21a19.25,19.25,0,0,1,6.52-3.89,23.47,23.47,0,0,1,8-1.36,21.61,21.61,0,0,1,3.93.37,28.11,28.11,0,0,1,3.74,1,17.26,17.26,0,0,1,3.3,1.54,14.08,14.08,0,0,1,2.61,2Z",
    transform: "translate(-28.64 -28.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M224.33,81.09v14a6.31,6.31,0,0,0,1,3.87c.66.86,1.85,1.29,3.56,1.29a12.47,12.47,0,0,0,1.87-.15,6,6,0,0,0,1.65-.44l.15,8.81a19.1,19.1,0,0,1-3.15.77,22.49,22.49,0,0,1-3.82.33,17.83,17.83,0,0,1-6.17-.92,9.53,9.53,0,0,1-4-2.65,10.36,10.36,0,0,1-2.16-4.12,20,20,0,0,1-.66-5.33V81.09h-5.87v-9h5.79V62.52h11.82v9.62h8.59v9Z",
    transform: "translate(-28.64 -28.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M249.07,60.47a6.28,6.28,0,0,1-.55,2.6,6.64,6.64,0,0,1-3.67,3.49,7.21,7.21,0,0,1-2.68.51,6.73,6.73,0,0,1-4.92-1.94,6.31,6.31,0,0,1-2-4.66,6.43,6.43,0,0,1,.51-2.53,6,6,0,0,1,1.47-2.1,8.1,8.1,0,0,1,2.2-1.43,6.61,6.61,0,0,1,2.72-.55,7,7,0,0,1,2.68.52,6.71,6.71,0,0,1,2.2,1.39,6.8,6.8,0,0,1,1.47,2.09,6.36,6.36,0,0,1,.55,2.61M236.15,72.14h12v36.55h-12Z",
    transform: "translate(-28.64 -28.64)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "248.76 80.05 235.77 80.05 221.38 43.5 234.67 43.5 242.37 67.21 242.59 67.21 250.3 43.5 263.14 43.5 248.76 80.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291.49,77.13A20.88,20.88,0,0,1,299,72.51,25.73,25.73,0,0,1,307.78,71a23.4,23.4,0,0,1,7.82,1.14,11.71,11.71,0,0,1,5.17,3.52,15,15,0,0,1,2.9,6,35.17,35.17,0,0,1,.92,8.63v18.42h-11V104.8h-.22a9,9,0,0,1-4.22,3.52,14.87,14.87,0,0,1-6.13,1.25,18.34,18.34,0,0,1-4.55-.59,13.27,13.27,0,0,1-4.29-1.9,10.27,10.27,0,0,1-3.19-3.53,10.77,10.77,0,0,1-1.25-5.43,9.22,9.22,0,0,1,2.16-6.38A14.25,14.25,0,0,1,297.47,88a29.5,29.5,0,0,1,7.6-1.76,78.77,78.77,0,0,1,8.15-.44V85.2a4.49,4.49,0,0,0-1.91-4,8.29,8.29,0,0,0-4.7-1.28,11.79,11.79,0,0,0-5,1.1,15.7,15.7,0,0,0-4.07,2.64Zm22.09,15.63H312c-1.32,0-2.65.07-4,.19a16.56,16.56,0,0,0-3.6.69,6.71,6.71,0,0,0-2.6,1.51,3.43,3.43,0,0,0-1,2.6,3.17,3.17,0,0,0,.48,1.77,3.65,3.65,0,0,0,1.21,1.17,5.15,5.15,0,0,0,1.69.62,9.11,9.11,0,0,0,1.83.19,7.43,7.43,0,0,0,5.62-2A7.57,7.57,0,0,0,313.58,94Z",
    transform: "translate(-28.64 -28.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M343.18,81.09v14a6.31,6.31,0,0,0,1,3.87c.67.86,1.85,1.29,3.56,1.29a12.6,12.6,0,0,0,1.88-.15,6,6,0,0,0,1.65-.44l.14,8.81a19.1,19.1,0,0,1-3.15.77,22.49,22.49,0,0,1-3.82.33,17.73,17.73,0,0,1-6.16-.92,9.4,9.4,0,0,1-4-2.65,10.25,10.25,0,0,1-2.17-4.12,20,20,0,0,1-.66-5.33V81.09h-5.87v-9h5.8V62.52h11.81v9.62h8.59v9Z",
    transform: "translate(-28.64 -28.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M390.75,90.85v1.47a12.42,12.42,0,0,1-.08,1.4H364.18a6.31,6.31,0,0,0,.91,2.79,8,8,0,0,0,2,2.16,9.48,9.48,0,0,0,2.71,1.43,9.37,9.37,0,0,0,3.12.52,10.09,10.09,0,0,0,4.84-1.07A9.43,9.43,0,0,0,381,96.8l8.37,5.28a16.89,16.89,0,0,1-6.79,5.77,22.54,22.54,0,0,1-9.8,2,23.3,23.3,0,0,1-7.78-1.29,18.87,18.87,0,0,1-6.42-3.74,17.37,17.37,0,0,1-4.33-6.06,20.29,20.29,0,0,1-1.58-8.22,20.71,20.71,0,0,1,1.54-8.11,18.33,18.33,0,0,1,4.19-6.16,18.6,18.6,0,0,1,6.24-3.93A21.3,21.3,0,0,1,372.4,71a19.78,19.78,0,0,1,7.41,1.36,16.3,16.3,0,0,1,5.8,3.93,18.24,18.24,0,0,1,3.78,6.24,24.07,24.07,0,0,1,1.36,8.36m-11.09-4.62a7.26,7.26,0,0,0-1.79-4.92,6.8,6.8,0,0,0-5.4-2,9.09,9.09,0,0,0-3.23.55,8.48,8.48,0,0,0-2.57,1.5,7.63,7.63,0,0,0-1.76,2.24,6.44,6.44,0,0,0-.73,2.68Z",
    transform: "translate(-28.64 -28.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M412.61,109.88a18.21,18.21,0,0,1-8.66-1.82,15.4,15.4,0,0,1-5.36-4.59,16.86,16.86,0,0,1-2.74-6.06,27.19,27.19,0,0,1-.77-6.18V61.86h4.77V90.7a22.92,22.92,0,0,0,.66,5.52,13.69,13.69,0,0,0,2.15,4.76,11.08,11.08,0,0,0,3.93,3.38,14.69,14.69,0,0,0,12,0,11.12,11.12,0,0,0,3.94-3.38,13.69,13.69,0,0,0,2.15-4.76,22.92,22.92,0,0,0,.66-5.52V61.86h4.77V91.23a27.19,27.19,0,0,1-.77,6.18,16.86,16.86,0,0,1-2.74,6.06,15.34,15.34,0,0,1-5.39,4.59,18.29,18.29,0,0,1-8.64,1.82",
    transform: "translate(-28.64 -28.64)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "425.35 80.05 420.59 80.05 420.59 37.45 404.91 37.45 404.91 33.22 441.03 33.22 441.03 37.45 425.35 37.45 425.35 80.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M495.5,69.4A11.52,11.52,0,0,0,491.59,66a11.89,11.89,0,0,0-5.75-1.29,12.41,12.41,0,0,0-3.51.53,10.06,10.06,0,0,0-3.24,1.62,8.36,8.36,0,0,0-2.35,2.75,8.14,8.14,0,0,0-.89,3.9,7.21,7.21,0,0,0,.86,3.7A8.13,8.13,0,0,0,479,79.68a13.08,13.08,0,0,0,3.24,1.69c1.21.44,2.47.88,3.79,1.32,1.63.53,3.26,1.11,4.91,1.72a17.87,17.87,0,0,1,4.46,2.42,11.71,11.71,0,0,1,3.23,3.77,12,12,0,0,1,1.25,5.79,12.86,12.86,0,0,1-1.33,6,12.68,12.68,0,0,1-3.48,4.2,14.46,14.46,0,0,1-4.88,2.45,19.75,19.75,0,0,1-5.52.79,21.11,21.11,0,0,1-4.24-.43,19.54,19.54,0,0,1-4-1.29,16.34,16.34,0,0,1-3.57-2.18,15.52,15.52,0,0,1-2.91-3l4.1-3a12.36,12.36,0,0,0,4.27,4.2,12,12,0,0,0,6.44,1.69,12.63,12.63,0,0,0,3.64-.56,10.29,10.29,0,0,0,3.34-1.72,9.37,9.37,0,0,0,2.45-2.85,7.78,7.78,0,0,0,1-3.93,7.88,7.88,0,0,0-1-4.07,8.46,8.46,0,0,0-2.55-2.71A15.22,15.22,0,0,0,488,88.12c-1.37-.49-2.8-1-4.3-1.46s-3.07-1-4.57-1.65a15.26,15.26,0,0,1-4-2.42,11.25,11.25,0,0,1-2.88-3.67,13.46,13.46,0,0,1,.26-11.18,12.41,12.41,0,0,1,3.54-4,15,15,0,0,1,4.83-2.32,19.9,19.9,0,0,1,5.23-.72,18.08,18.08,0,0,1,8.13,1.68,14,14,0,0,1,5.1,4Z",
    transform: "translate(-28.64 -28.64)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateLogo);
export default __webpack_public_path__ + "static/media/activate-logo.9f922171.svg";
export { ForwardRef as ReactComponent };